<template>
  <div>
    <div class="flush-left">
      <label for="exampleInputEmail1" v-if="label !== ''">{{label}}:</label>
    </div>
    <div class="input-group">
      <input type="text" class="form-control" ref="copy_input" id="copy_input" v-model="text" v-bind="$attrs" />
      <span class="input-group-append btn" @click="copy()" >
        <span class="input-group-text">
          <i v-if="showCheck" class="bi bi-check2 text-success"/>
          <i v-else class="bi bi-clipboard"/>
        </span>
      </span>
    </div>
  </div>
</template>


<script>

export default {

  methods: {
    copy () {
      navigator.clipboard.writeText(this.text);
      this.$emit('click');
    }
  },
  props : {
    text: {
      required: true,
      type: String
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    showCheck: {
      required: false,
      type: Boolean,
      default: false
    }
  },
}
</script>


<style scoped>
.input-group-text {
  background: white;
  color: #495057;
  border: 1px solid #ced4da;
}
.input-group-append {
  margin: -1px 0 0 -1px;
}

.btn {
  padding: 0;
}

#copy_input {
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// CopyPasteInput.vue?21d9c8ff